import React from 'react';
import { StarIcon } from 'lucide-react';
const Testimonials = () => {
  const testimonials = [{
    id: 1,
    text: 'Ahora la cena no me da estrés, ¡hasta disfruto cocinar!',
    stars: 5
  }, {
    id: 2,
    text: 'Mis hijos piden los tacos exprés del ebook todas las semanas.',
    stars: 5
  }, {
    id: 3,
    text: 'Ahorré más dinero del que imaginaba dejando de pedir comida afuera.',
    stars: 5
  }];
  return <section className="w-full py-16 px-6 md:px-12 lg:px-24" data-id="element-107">
      <div className="max-w-4xl mx-auto" data-id="element-108">
        <h2 className="text-3xl font-bold text-center text-[#C17A47] mb-4" data-id="element-109">
          Lo que dicen las mamás
        </h2>
        <p className="text-lg text-center text-[#6B5A45] mb-12" data-id="element-110">
          Más de 2,500 mamás ya usan estas recetas y lo confirman:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-111">
          {testimonials.map(testimonial => <div key={testimonial.id} className="bg-white p-6 rounded-lg shadow-md" data-id="element-112">
              <div className="flex mb-4" data-id="element-113">
                {[...Array(testimonial.stars)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-[#FFB74D]" fill="#FFB74D" data-id="element-114" />)}
              </div>
              <p className="text-[#6B5A45]" data-id="element-115">✨ "{testimonial.text}"</p>
            </div>)}
        </div>
        <div className="mt-16 bg-[#F9F4EE] p-8 rounded-lg" data-id="element-116">
          <h3 className="text-2xl font-semibold text-[#C17A47] mb-4" data-id="element-117">
            Visualízate dentro de 7 días:
          </h3>
          <p className="text-lg text-[#6B5A45]" data-id="element-118">
            Tus cenas… rápidas. Tus hijos… felices. Tu rutina… ligera.
          </p>
          <p className="text-lg text-[#6B5A45] mt-4" data-id="element-119">
            Y tú… con tiempo extra para descansar, leer o simplemente disfrutar.
          </p>
        </div>
      </div>
    </section>;
};
export default Testimonials;